module.exports = __webpack_public_path__ + "static/img/superiority2.ffd190fa.png";